import { render, staticRenderFns } from "./ContactListLink.vue?vue&type=template&id=51353db4&"
import script from "./ContactListLink.vue?vue&type=script&lang=ts&"
export * from "./ContactListLink.vue?vue&type=script&lang=ts&"
import style0 from "./ContactListLink.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IconArrowTopRight: require('/Users/markussh/git/theodora-tech-website/src/components/icon/ArrowTopRight.vue').default})
